import { render, staticRenderFns } from "./BatchAssignCategoryModal.vue?vue&type=template&id=bf075008"
import script from "./BatchAssignCategoryModal.vue?vue&type=script&lang=js"
export * from "./BatchAssignCategoryModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports